<div class="search-container-details">
    <div class="tab-title-icon">
        <cll-icon class="tab-icon" type="outlined">volunteer_activism</cll-icon>
        <div class="accordion-sub-title-accordion">
            <span class="detail-table-title">Providers</span>
            <span class="detail-table-sub-title">Providers associated with this region</span>
        </div>
    </div>
</div>

@if (regionData?.result$ | async; as result) {
    @if (result.value?.data; as regionData) {
        <div class="tabs-table-container">
            <table class="cll-table">
                <thead>
                <tr>
                    <th>Provider reference</th>
                    <th>Provider name</th>
                    <th>Main email address</th>
                    <th>Telephone number</th>
                    <th>Zones</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    @if (regionData?.providers; as providers) {
                        @if (providers.length > 0) {
                            @for (providers of providers; track providers.id) {
                                <tr>
                                    <td>{{ providers.reference }}</td>
                                    <td>{{ providers.name }}</td>
                                    <td>{{ providers.email }}</td>
                                    <td>
                                        @if (providers?.contact_numbers!.length > 0) {
                                            {{ providers.contact_numbers[0].number }}
                                        }
                                    </td>
                                    <td></td>
                                    <td class="align-right">

                                            <button cll-icon-button [cllMenuTriggerFor]="menu"
                                                    (click)="$event.stopPropagation()">
                                                <cll-icon>more_vert</cll-icon>
                                            </button>

                                            <ng-template #menu>
                                                <cll-menu>
                                                    <button cllMenuItem [routerLink]="['/providers', providers.id]"
                                                            target="_blank" rel="noopener noreferrer">
                                                        <div class="view-provider-menu-item">
                                                            <div class="view-icon-text-item">
                                                                <cll-icon type="outlined">visibility</cll-icon>
                                                                View
                                                            </div>
                                                            <cll-icon type="outlined">open_in_new</cll-icon>
                                                        </div>
                                                    </button>
                                                     @if (providers.status) {
                                                        @if ((user()?.permissions?.permissions ?? []).includes('region.update')) {
                                                            <button cllMenuItem (click)="removeFromRegion(providers)">
                                                                <div class="view-provider-menu-item">
                                                                    <div class="view-icon-text-item">
                                                                        <cll-icon type="outlined">remove_circle_outline</cll-icon>
                                                                        Remove from region
                                                                    </div>
                                                                </div>
                                                            </button>
                                                        }
                                                    }
                                                </cll-menu>
                                            </ng-template>
                                    </td>
                                </tr>
                            }
                        } @else {
                            <tr>
                                <td colspan="6" class="no-data-row">
                                    <div class="no-data-wrapper-tabs">
                                        No Providers found.
                                    </div>
                                </td>
                            </tr>
                        }
                    }
                </tbody>
            </table>
        </div>
    }
}
